import BaseFieldHOC from "./BaseFieldHOC";

import RadioCardInput, { RadioCardInputProps } from "./inputs/RadioCardInput";
import TextInput, { TextInputProps } from "./inputs/TextInput";
import PasswordInput from "./inputs/PasswordInput";
import ToggleRowInput, { ToggleRowInputProps } from "./inputs/ToggleRowInput";
import CheckboxCardInput, { CheckboxCardInputProps } from "./inputs/CheckboxCardInput";
import SelectInput, { SelectInputProps } from "./inputs/SelectInput";
import MultiSelectInput, { MultiSelectInputProps } from "./inputs/MultiSelectInput";
import RadioInput, { RadioInputProps } from "./inputs/RadioInput";
import TextArea from "@/components/forms/inputs/TextArea";
import SliderInput, { SliderInputProps } from "./inputs/SliderInput";
import CheckboxInput, { CheckboxInputProps } from "./inputs/CheckboxInput";

const RadioCardField = BaseFieldHOC<RadioCardInputProps>(RadioCardInput);
const TextField = BaseFieldHOC<TextInputProps>(TextInput);
const SecretField = BaseFieldHOC<TextInputProps>(PasswordInput);
const PasswordField = BaseFieldHOC<TextInputProps>(PasswordInput);
const SliderField = BaseFieldHOC<SliderInputProps>(SliderInput);
const TextAreaField = BaseFieldHOC<TextInputProps>(TextArea);
const ToggleRowField = BaseFieldHOC<ToggleRowInputProps>(ToggleRowInput);
const CheckboxCardField = BaseFieldHOC<CheckboxCardInputProps>(CheckboxCardInput);
const SelectInputField = BaseFieldHOC<SelectInputProps>(SelectInput);
const MultiSelectInputField = BaseFieldHOC<MultiSelectInputProps>(MultiSelectInput);
const RadioInputField = BaseFieldHOC<RadioInputProps>(RadioInput);
const CheckboxField = BaseFieldHOC<CheckboxInputProps>(CheckboxInput);

export {
  RadioCardField,
  TextField,
  SecretField,
  PasswordField,
  TextAreaField,
  ToggleRowField,
  CheckboxCardField,
  SelectInputField,
  MultiSelectInputField,
  RadioInputField,
  SliderField,
  CheckboxField
};
